import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const s = "cities";
class o extends a {
  /**
   * Searches for cities based on a query string.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/cities`
   *
   * @param {string} query - (Optional) A string used to filter cities in the search request. Defaults to an empty string.
   * @returns {Promise<Array<CityObject>>} A promise resolving to an array of city objects matching the search criteria.
   */
  search = async (t = "") => {
    const { data: e } = await this.get(s, { query: t });
    return e;
  };
  /**
   * Retrieves the top cities from the API.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/cities/top`
   *
   * @returns {Promise<Array<CityObject>>} A promise resolving to an array of top city objects.
   */
  getTopCities = async () => {
    const { data: t } = await this.get(`${s}/top`);
    return t;
  };
}
export {
  s as CITIES_RESOURCE_URI,
  o as Cities
};
